import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

// AI-assisted: migrate-ngx-translate-v18
export function provideAppTranslationLoader() {
  return provideTranslateHttpLoader( {
    prefix: '../../../assets/i18n/',
    suffix: '.json',
    failOnError: true
  } );
}
